<template>
  <div class="wrapper  w-100">
    <v-list
      :two-line="twoLine"
      class="py-0"
      :class="{
        'elevation-1': elevation,
      }">
      <slot name="search-bar"></slot>
      <slot v-if="data.items.length" name="content" :items="data.items"></slot>
      <v-list-tile
        v-else
        class="text-center py-1 text-xs-center no-rows">
        <v-icon class="mr-4">
          fas fa-exclamation-circle
        </v-icon>
        <h4>
          No hay nada que mostrar
        </h4>
      </v-list-tile>
    </v-list>
    <v-layout v-if="data.pages" row wrap justify-center align-center>
      <v-flex>
        <slot name="footer"></slot>
      </v-flex>
      <v-flex>
        <div class="pagination mt-4 text-xs-right">
          <v-btn small flat class="ml-0 mr-1" @click="page -= 1" :disabled="page === 1">
            <v-icon small>
              fas fa-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            v-if="currentPageChunk"
            class="ml-0 mr-1"
            @click="page = pageChunks[currentPageChunk - 1][0] + 1"
            small
            flat>
            ...
          </v-btn>
          <v-btn
            v-for="i in pageChunks[currentPageChunk]"
            :key="`button-${i}`"
            :class="{'k-orange': (i + 1) === page}"
            class="ml-0 mr-1"
            @click="page = (i + 1)"
            small
            flat>
            {{ i + 1 }}
          </v-btn>
          <v-btn
            v-if="pageChunks.length > (currentPageChunk + 1)"
            class="ml-0 mr-1"
            @click="page = pageChunks[currentPageChunk + 1][0] + 1"
            small
            flat>
            ...
          </v-btn>
          <v-btn flat small class="mx-0" @click="page += 1" :disabled="page === data.pages">
            <v-icon small>
              fas fa-chevron-right
            </v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    searchOnCreate: {
      type: Boolean,
      default: true,
    },
    twoLine: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String,
      required: true,
    },
    search: {
      type: String,
      required: false,
    },
    filters: {
      type: Object,
      required: false,
    },
    limit: {
      type: Number,
      default: 10,
    },
    refresh: {
      type: Boolean,
      default: false,
    },
    elevation: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.$on('update', this.searchElements);
    if (this.searchOnCreate) {
      this.searchElements();
    }
  },
  destroyed() {
    this.cancelToken.cancel('Canceled by user');
  },
  data() {
    return {
      cancelToken: this.axios.CancelToken.source(),
      page: 1,
      data: {
        items: [],
        total: 0,
        pages: 0,
      },
    };
  },
  computed: {
    pageChunks() {
      return _.chunk([...Array(this.data.pages).keys()], 6);
    },
    currentPageChunk() {
      let diff = this.page / 6;
      if (Number.isInteger(diff)) {
        diff -= 1;
      }
      return Math.floor(diff);
    },
  },
  methods: {
    searchElements() {
      this.cancelToken.cancel('Canceled by user');
      this.cancelToken = this.axios.CancelToken.source();
      this.axios.get(this.url, {
        params: {
          paginate: 1,
          page: this.page,
          limit: this.limit,
          ...this.filters,
          ...this.search && {
            search: this.search,
          },
        },
        cancelToken: this.cancelToken.token,
      }).then((response) => {
        if (this.page === 1) {
          this.data = response.data;
          this.$emit('send-total', response.data.total);
        } else {
          this.data.items = response.data.items;
        }
      }).catch((error) => {
        if (error.message !== 'Canceled by user' && error.response.status !== 403) {
          // this.$store.dispatch('SHOW_ERROR_DIALOG', 'Ocurrio un error');
        }
      });
    },
  },
  watch: {
    search: _.debounce(function () { // eslint-disable-line
      if (this.page !== 1) {
        this.page = 1;
      } else {
        this.searchElements();
      }
    }, 500),
    filters: {
      handler() {
        if (this.page !== 1) {
          this.page = 1;
        } else {
          this.searchElements();
        }
      },
      deep: true,
    },
    data: {
      deep: true,
      handler() {
        this.$emit('items-reload', this.data.items);
      },
    },
    page: _.debounce(function () { // eslint-disable-line
      this.searchElements();
    }, 200),
    refresh(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.searchElements();
      }
    },
  },
};
</script>

<style scoped>
.pagination button {
  min-width: auto !important;
}
.pagination >>> .v-btn__content {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.text-center >>> .list__tile {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/global/DataTable2.vue